import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$o = ".Column_module_column__efe9ce44{display:flex;flex-direction:column}";
collectCss(css$o);
var modules_82bdfbfc = {"column":"Column_module_column__efe9ce44"};

export { css$o as css, modules_82bdfbfc as default };
//# sourceMappingURL=Column.module.css.mjs.map
